import React from 'react';

import LloydMatChooserItem from './LloydMatChooserItem';
import clsx from "clsx";
import {camelizeKeysDeep} from "../../../ReduxStore/Helpers/transformObject";

/**
 * 2025-06 fully modernized, here and below. All camelCase.
 *
 * The first part of the LloydUI - at the top, present images of
 * floor mats with a checkbox for each.
 */
export default function LloydMatChooserItems({
  itemList, lloydCart, callbacks}) {

  let count = itemList.length;

  // for counts of 5 or 9 use a 3-col layout to avoid orphans on last line.
  // on mobile, no grid.
  let columns = (count === 5 || count === 9) ? 3 : 4;
  let className= `grid gap-2 lg:grid-cols-${columns}`;

  return <div className={className}>
    {
      itemList.map(item => {
        let partNumber = item.extendedPartNumber;
        let cartItem = lloydCart?.getItem(partNumber);

        return <LloydMatChooserItem
          key={partNumber}
          lloydItem={item}
          callbacks={callbacks}
          cartItem={cartItem}/>
      })
    }
  </div>
}
